import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DataAttributeDirective } from '@shared/directives/data-attribute.directive';
import { TranslocoDirective } from '@jsverse/transloco';
import { UserAssistanceDialogService } from '../../services/user-assistance-dialog.service';

@Component({
  selector: 'tiss-selection-helper',
  imports: [DataAttributeDirective, TranslocoDirective],
  templateUrl: './selection-helper.component.html',
  styleUrl: './selection-helper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [UserAssistanceDialogService],
})
export class SelectionHelperComponent {
  constructor(private userAssistanceDialogService: UserAssistanceDialogService) {}

  initiateAssistanceInSelection(): void {
    this.userAssistanceDialogService.openAssistanceInSelectionDialog();
  }
}
